import CreateMetadataFormFields from '../types/createMetadataFormFields.type';
import Module from '../types/module.type';
import getRequiredLevelOptions from './getRequiredLevelOptions';

const getFormFieldsToSave = (
  formFields: CreateMetadataFormFields,
  module: Module,
) => {
  const {
    metadata_key,
    metatype_id,
    required_level,
    metadata_category,
    description,
  } = formFields;

  const availableOptions = getRequiredLevelOptions({ module });
  const selectedOptions = required_level;

  const levelConstraint = availableOptions.reduce(
    (acc, option) => {
      acc[option.value] = selectedOptions.find(
        (selectedOption) => selectedOption.value === option.value,
      )
        ? 'REQUIRED'
        : 'OPTIONAL';

      return acc;
    },
    {} as Record<string, string>,
  );

  return {
    metadata_key,
    metatype_id,
    level_constraint: levelConstraint,
    metadata_category,
    metadata_description: description,
  };
};

export default getFormFieldsToSave;
